import { SOCIALS } from "@/lib/site";

// Inline SVG brand marks (single-color) — keeps the neon aesthetic consistent
const XIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);
const DiscordIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M20.317 4.37a19.79 19.79 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.74 19.74 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.058a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.1 13.1 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.009c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.3 12.3 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.84 19.84 0 0 0 6.002-3.03.077.077 0 0 0 .032-.055c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.42 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.334-.956 2.419-2.157 2.419zm7.975 0c-1.183 0-2.157-1.085-2.157-2.42 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.334-.946 2.419-2.157 2.419z" />
  </svg>
);
const TikTokIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.72a8.16 8.16 0 0 0 4.77 1.52V6.79a4.85 4.85 0 0 1-1.84-.1z" />
  </svg>
);

const ICONS = { x: XIcon, discord: DiscordIcon, tiktok: TikTokIcon };
const ACCENTS = {
  x: { border: "hover:border-white/70", text: "group-hover:text-white" },
  discord: { border: "hover:border-[#5865F2]", text: "group-hover:text-[#5865F2]" },
  tiktok: { border: "hover:border-[#00f0ff]", text: "group-hover:text-[#00f0ff]" },
};

export const SocialLinks = ({ compact = false, className = "" }) => {
  if (compact) {
    return (
      <div className={`flex items-center gap-2 ${className}`} data-testid="social-links-compact">
        {SOCIALS.map((s) => {
          const Icon = ICONS[s.key];
          const a = ACCENTS[s.key];
          return (
            <a key={s.key} href={s.url} target="_blank" rel="noopener noreferrer"
              aria-label={s.label} title={s.label}
              data-testid={`social-${s.key}`}
              className={`group w-9 h-9 rounded-full grid place-items-center border border-white/15 ${a.border} text-white/60 ${a.text} transition-colors`}>
              <Icon className="w-4 h-4" />
            </a>
          );
        })}
      </div>
    );
  }
  return (
    <div className={`grid grid-cols-3 gap-3 ${className}`} data-testid="social-links">
      {SOCIALS.map((s) => {
        const Icon = ICONS[s.key];
        const a = ACCENTS[s.key];
        return (
          <a key={s.key} href={s.url} target="_blank" rel="noopener noreferrer"
            data-testid={`social-${s.key}-large`}
            className={`group flex items-center gap-3 rounded-xl border border-white/15 ${a.border} bg-black/40 px-4 py-3 transition-colors`}>
            <span className={`w-9 h-9 shrink-0 rounded-lg grid place-items-center bg-white/5 text-white/70 ${a.text} transition-colors`}>
              <Icon className="w-4 h-4" />
            </span>
            <span className="min-w-0">
              <span className={`block font-mono text-[10px] uppercase tracking-widest text-white/40 ${a.text} transition-colors`}>{s.key === "x" ? "Follow on X" : s.key === "discord" ? "Join Discord" : "Watch on TikTok"}</span>
              <span className="block font-display font-bold text-sm text-white truncate">{s.handle}</span>
            </span>
          </a>
        );
      })}
    </div>
  );
};
